import { useCallback } from "react";

import { Run, RunState, RunType, Stack } from "types/generated";

import useCanCreateTask from "./useCanCreateTask";

/**
 * Check if the current user can perform the task again (history run)
 */
const useCanPerformTaskAgain = (): ((run: Run, stack?: Stack) => boolean) => {
  const canCreateTask = useCanCreateTask();

  return useCallback(
    (run: Run, stack?: Stack) => {
      const canPerformAgain =
        run.type === RunType.Task &&
        (run.state === RunState.Failed ||
          run.state === RunState.Discarded ||
          run.state === RunState.Stopped ||
          run.state === RunState.Finished);

      return canPerformAgain && canCreateTask(stack);
    },
    [canCreateTask]
  );
};

export default useCanPerformTaskAgain;
